<audio id="{{ id }}" class="op-player__media" #openplayer controls playsinline>
    <source src="{{ source }}" />
</audio>
